import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Layout from './Layout/Layout';
import Modal from './Modal';

/**
 * Layout 래퍼 컴포넌트
 * 로그인 페이지에서는 Layout을 표시하지 않고, 그 외 페이지에서는 Layout을 표시합니다.
 */
const Index = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <>
      {pathname === '/login' ? children : <Layout>{children}</Layout>}
      <Modal />
    </>
  );
};

export default Index;
